import { render } from "./PostscanButton.vue?vue&type=template&id=5235cee2"
import script from "./PostscanButton.vue?vue&type=script&lang=js"
export * from "./PostscanButton.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__